import { render } from "./RemoveButton.vue?vue&type=template&id=9384562c&scoped=true&ts=true"
import script from "./RemoveButton.vue?vue&type=script&lang=ts"
export * from "./RemoveButton.vue?vue&type=script&lang=ts"

import "./RemoveButton.vue?vue&type=style&index=0&id=9384562c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9384562c"]])

export default __exports__